import './styles.css';
import { mountApp } from './app';
import { clearActivityLog } from './lib/activity-log';
import { initTheme } from './lib/theme';

initTheme();
clearActivityLog();
mountApp(document.getElementById('app')!);

const registerServiceWorker = () => {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
};

const scheduleServiceWorker = () => {
  window.setTimeout(() => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(registerServiceWorker, { timeout: 4000 });
      return;
    }
    registerServiceWorker();
  }, 10000);
};

window.addEventListener('load', scheduleServiceWorker, { once: true });
